import { PriceScopeType } from '../../constants/price-scope-type.js';
// WHY: scope-refine.ts needs the indefinite article for its validation messages, but PriceScopeTypeRule is a pricing-domain type and shouldn't carry an English-grammar concern.
export const SCOPE_ARTICLE = {
    [PriceScopeType.CATEGORY_DEFAULT]: 'a',
    [PriceScopeType.MARKET]: 'a',
    [PriceScopeType.PRODUCT]: 'a',
    [PriceScopeType.ACCOUNT]: 'an',
    [PriceScopeType.ACCOUNT_PRODUCT]: 'an',
};
//# sourceMappingURL=scope-article.js.map